import { render } from "./PurchaseSuccess.vue?vue&type=template&id=4db549dc&scoped=true"
import script from "./PurchaseSuccess.vue?vue&type=script&lang=js"
export * from "./PurchaseSuccess.vue?vue&type=script&lang=js"

import "./PurchaseSuccess.vue?vue&type=style&index=0&id=4db549dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db549dc"]])

export default __exports__